export const FETCH_USER_SKILL_REQUEST = 'fetch_user_skill_request';
export const FETCH_USER_SKILL_SUCCESS = 'fetch_user_skill_success';
export const FETCH_USER_SKILL_FAILURE = 'fetch_user_skill_failure';
